import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.dom-collections.iterator"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cookies from 'js-cookie';
import StatusBadge from './StatusBadge';
export default {
  name: 'side-nav',
  components: {
    StatusBadge
  },

  data() {
    return {
      isActive: !(cookies.get('frame.styleguide_drawer') === 'false'),
      menu: []
    };
  },

  mounted() {
    this.menu = [...document.querySelectorAll('.sg-content-section')].map(section => {
      return {
        title: section.id,
        links: [...section.querySelectorAll('.sg-content-block')].map(template => {
          return {
            title: template.dataset.title,
            status: template.dataset.status
          };
        })
      };
    });
    this.$root.$on('navigation:toggle', () => {
      this.toggleMenu();
    });
  },

  methods: {
    toggleMenu() {
      this.isActive = !this.isActive;
      cookies.set('frame.styleguide_drawer', this.isActive, 150, '/', Shopify.shop);
    },

    toggleContent(title) {
      this.$root.$emit('updateView', title);

      if (!window.matchMedia('(min-width: 576px)').matches) {
        this.isActive = false;
      }
    }

  }
};